// @module Convergence.TopDealsExt.TopDealsExt
define('Convergence.TopDealsExt.TopDealsExt.ItemCell.View'
    ,	[
        'topdeals_itemcell.tpl'
        
        ,	"Convergence.TopDealsExty.TopDealsExt.Collection"
        
        ,	'Backbone'
        ,   'Facets.ItemCell.View'
        ,   'Product.Model'
        ,   'Convergence.TopDealsExt.TopDealsExt.QuickAddtoCart.View'
        ]
    , function (
        topdeals_itemcell_tpl
        
        ,	TopDealsExtCollection
        
        ,	Backbone
        ,   FacetsItemCellView
        ,   ProductModel
        ,   CartQuickAddToCartView
    )
    {
        'use strict';
    
        // @class Convergence.TopDealsExt.TopDealsExt.View @extends Backbone.View
        return FacetsItemCellView.extend({
    
            template: topdeals_itemcell_tpl
    
        ,	initialize: function (options) {
            FacetsItemCellView.prototype.initialize.apply(this, arguments);
                this.model = options.model;
                
                
                
            }
       
        ,	events: {
            }
    
        ,	bindings: {
            }
    
        , 	childViews:  _.extend({},FacetsItemCellView.prototype.childViews, {
                'Cart.QuickAddToCart.new': function() {
                    const product = new ProductModel({
                        item: this.model,
                        quantity: this.model.get('_minimumQuantity', true)
                    });
    
                    return new CartQuickAddToCartView({
                        model: product,
                        application: this.options.application
                    });
                },
            })
    
            //@method getContext @return Convergence.TopDealsExt.TopDealsExt.View.Context
        ,	getContext: function getContext()
            {
                
                //@class Convergence.TopDealsExt.TopDealsExt.View.Context
                var product = new ProductModel({
                    item: this.model
                });
                
                return {
                   itemId: this.model.get('_id'),
            // @property {String} name
            name: this.model.get('_name'),
            // @property {String} url
            url: this.model.get('_url'),
            // @property {String} sku
            sku: this.model.getSku(),
            // @property {Boolean} isEnvironmentBrowser
            isEnvironmentBrowser:
                SC.ENVIRONMENT.jsEnvironment === 'browser' && !SC.ENVIRONMENT.isTouchEnabled,
            // @property {ImageContainer} thumbnail
            thumbnail: this.model.getThumbnail(),
            // @property {Boolean} itemIsNavigable
            itemIsNavigable: !_.isUndefined(this.options.itemIsNavigable)
                ? !!this.options.itemIsNavigable
                : true,
            // @property {Boolean} showRating
            showRating: SC.ENVIRONMENT.REVIEWS_CONFIG && SC.ENVIRONMENT.REVIEWS_CONFIG.enabled,
            // @property {Number} rating
            rating: this.model.get('_rating'),
            // @property {String} track_productlist_list
            track_productlist_list: this.model.get('track_productlist_list'),
            // @property {String} track_productlist_position
            track_productlist_position: this.model.get('track_productlist_position'),
            // @property {String} track_productlist_category
            track_productlist_category: this.model.get('track_productlist_category')
                };
            }
        });
    });
    
